import React from "react";
import {
  p2pFixtureStatusShort,
  p2pIsLiveFixture,
  p2pMatchHeadline,
} from "../../users/userP2PHelpers";
import P2PTeamLogo from "./P2PTeamLogo";

export default function P2PDuelMatchup({
  duel,
  compact = false,
  showLogos = true,
  alignLeft = false,
  scalableLogos = false,
  logoSize,
  as = "span",
}) {
  const home = duel?.matchHome || "Home";
  const away = duel?.matchAway || "Away";
  const homeLogo = duel?.homeLogo;
  const awayLogo = duel?.awayLogo;
  const status = p2pFixtureStatusShort(duel);
  const live = p2pIsLiveFixture(duel);
  const Tag = as;
  const resolvedLogoSize = scalableLogos ? undefined : logoSize ?? (compact ? 22 : 40);
  const withLogos = Boolean(showLogos);

  return (
    <Tag
      className={`ap2p-matchup${compact ? " ap2p-matchup-compact" : ""}${withLogos ? " ap2p-matchup-with-logos" : ""}${compact && withLogos ? " ap2p-matchup-compact-logos" : ""}${alignLeft ? " ap2p-matchup-align-left" : ""}`}
      title={p2pMatchHeadline(duel)}
    >
      <span className="ap2p-matchup-side ap2p-matchup-side-home">
        {withLogos ? (
          <P2PTeamLogo url={homeLogo} name={home} size={resolvedLogoSize} sizeFromCss={scalableLogos} />
        ) : null}
        <span className="ap2p-matchup-team" title={home}>
          {home}
        </span>
      </span>
      <span
        className={`ap2p-matchup-status${live ? " ap2p-matchup-status-live" : ""}`}
        aria-label={`Fixture status ${status}`}
      >
        {status}
      </span>
      <span className="ap2p-matchup-side ap2p-matchup-side-away">
        {withLogos ? (
          <P2PTeamLogo url={awayLogo} name={away} size={resolvedLogoSize} sizeFromCss={scalableLogos} />
        ) : null}
        <span className="ap2p-matchup-team" title={away}>
          {away}
        </span>
      </span>
    </Tag>
  );
}
